<script lang="ts" setup>
import { computed } from 'vue';
import { isValidEmail } from '@/utils/forms';

const props = defineProps<{
  contactSearch: string;
}>();
const isContactSearchValidEmail = computed(() => isValidEmail(props.contactSearch));

defineEmits<{
  'add-contact': [email: string];
}>();
</script>

<template>
  <div class="bg-shade-100 px-3 py-2">
    <span
      class="add-custom-contact valid"
      @click="$emit('add-contact', contactSearch)"
      v-if="isContactSearchValidEmail"
    >
      + Add {{ contactSearch }}
    </span>
    <span class="add-custom-contact invalid" v-else>
      + Add {{ contactSearch }}
      <span class="pl-2 text-xs font-light text-shade-800">(Enter a valid email)</span>
    </span>
  </div>
</template>

<style scoped>
.add-custom-contact {
  @apply text-sm font-bold text-highlight-600;
}
</style>
